import ScrollTrigger from 'gsap/ScrollTrigger'

let pending = 0

/**
 * Re-measure the scroll world after the page height changes.
 *
 * ScrollTrigger measures each trigger once and caches the result, so anything
 * that adds or removes markup client-side — the collection filter tabs, the
 * news year select, "Load More" — leaves it aiming at where the page used to
 * be. On a short viewport the miss shows: filtering down to a few cards
 * shortens the page, the browser clamps the scroll position, and elements that
 * are now on screen (the footer, usually) never reach their old start and stay
 * stuck at opacity 0.
 *
 * Lenis is re-measured first — it caches the scroll limit and would otherwise
 * keep animating past the new bottom — then the triggers are recalculated,
 * which fires the ones that are in view at the new positions.
 *
 * The work waits a frame so the browser has laid the new DOM out, and repeated
 * calls within that frame collapse into one.
 *
 * @param {import('lenis').default|null} [lenis] - smooth-scroll instance to re-measure
 */
export function refreshScroll(lenis = null) {
  cancelAnimationFrame(pending)
  pending = requestAnimationFrame(() => {
    lenis?.resize()
    ScrollTrigger.refresh()
  })
}
